import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ModuleLayout from '../../layout/ModuleLayout';
import { useTranslation } from 'react-i18next';
import {
  FaCog,
  FaUser,
  FaUserAlt,
  FaUserCheck,
  FaUserFriends
} from 'react-icons/fa';

// Import components
import ProfilePage from '../Profil/ProfilePage';
import SignUpForm from '../Profil/UserPage';

const SettingsModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: 'settings',
    title: t('modules.settings.title'),
    description: t('modules.settings.description'),
    icon: FaCog,
    color: '#6c757d',
    menuItems: [
      { path: '/settings-module/profile', icon: FaUserCheck, label: t('nav.profile') },
      { path: '/settings-module/users', icon: FaUserFriends, label: t('nav.users') }
    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        <Route path="/" element={<Navigate to="/settings-module/profile" replace />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/users" element={<SignUpForm />} />
      </Routes>
    </ModuleLayout>
  );
};

export default SettingsModule;
